import { StyleSheet, View } from "react-native";

import { radii, useThemedStyles, type ThemeColors } from "~/styles/theme";

export function CheckboxMark({ checked }: { checked: boolean }) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View
      accessibilityElementsHidden
      importantForAccessibility="no"
      style={[stylesheet.checkbox, checked ? stylesheet.checked : null]}
    />
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    checkbox: {
      width: 22,
      height: 22,
      borderWidth: 1.5,
      borderColor: colors.borderStrong,
      borderRadius: radii.s,
      backgroundColor: colors.elevated,
    },
    checked: {
      borderColor: colors.primary,
      backgroundColor: colors.primary,
    },
  });
